<template>
  <div class="xband-page">
    <img
      v-for="(item, index) in sections"
      :key="item.file"
      class="section"
      :class="{ 'is-full': item.full }"
      :src="srcOf(item)"
      :srcset="srcsetOf(item)"
      sizes="(max-width: 800px) 100vw, 800px"
      :alt="item.alt"
      :width="item.w"
      :height="item.h"
      :loading="index < 2 ? 'eager' : 'lazy'"
      decoding="async"
    >
    <!-- 底部下载入口：静态内容，不依赖接口 -->
    <div class="download-box">
      <h2 class="download-title">{{ $t('xband.download') }}</h2>
      <p class="download-desc">{{ $t('xband.downloadDesc') }}</p>
      <div class="download-actions">
        <a
          class="download-btn"
          :href="appStoreUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            class="icon"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
          </svg>
          <span>{{ $t('xband.appStore') }}</span>
        </a>
        <a
          class="download-btn"
          :href="googlePlayUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            class="icon"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195a1.466 1.466 0 0 0-.946-.179l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z" />
          </svg>
          <span>{{ $t('xband.googlePlay') }}</span>
        </a>
      </div>
    </div>
    <!-- 固定悬浮购买按钮（文案随语言切换：中文"购买" / 英文"Buy Now"） -->
    <a
      class="buy-float"
      :href="buyUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span class="buy-float-text">{{ $t('xband.buy') }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'XbandPage',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      // 下载入口地址
      appStoreUrl: 'https://apps.apple.com/cn/app/x-band/id6757697213',
      googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.jstyle.xband&pcampaignid=web_share',
      // 悬浮购买按钮跳转地址
      buyUrl: 'https://www.codex-watches.com',
      // 设计稿分页图，按顺序纵向拼接。
      // 1x 图统一 800px 宽（q80，与页面最大显示宽度一致）
      // x2 标记为 true 的另外提供 1200px / 1600px（q72）供高分屏使用
      // w/h 为 1x 图实际尺寸，用于占位避免懒加载抖动
      sections: [
        {
          file: 'xband-01-intro.jpg',
          alt: 'CODEX XBAND - 24/7 Health Insights, Zero Compromise',
          w: 800,
          h: 818,
          x2: true,
        },
        {
          file: 'xband-02-background.jpg',
          alt: 'XBAND Background',
          w: 800,
          h: 869,
          x2: true,
        },
        {
          file: 'xband-03-golf.jpg',
          alt: 'XBAND on the golf course',
          w: 800,
          h: 1028,
          x2: true,
        },
        {
          file: 'xband-04-product-intro.jpg',
          alt: 'XBAND Product Introduction',
          w: 800,
          h: 1061,
          x2: true,
        },
        {
          file: 'xband-05-features.jpg',
          alt: 'XBAND Smart Detection Module',
          w: 680,
          h: 492,
        },
        {
          file: 'xband-06-features-sleep.jpg',
          alt: 'XBAND Product Features',
          w: 800,
          h: 1006,
          x2: true,
        },
        {
          file: 'xband-07-function-1.jpg',
          alt: 'XBAND Sleep Monitoring',
          w: 680,
          h: 713,
        },
        {
          file: 'xband-08-function-2.jpg',
          alt: 'XBAND Sports and Health Monitoring',
          w: 800,
          h: 787,
          x2: true,
        },
        {
          file: 'xband-09-health-score.jpg',
          alt: 'XBAND Health Score',
          w: 800,
          h: 710,
          x2: true,
        },
        {
          file: 'xband-10-family-sharing.jpg',
          alt: 'XBAND Family Sharing',
          w: 680,
          h: 835,
        },
        {
          file: 'xband-11-color-white.jpg',
          alt: 'XBAND Color Options - Moonlight White',
          w: 800,
          h: 834,
          x2: true,
        },
        {
          file: 'xband-12-color-black.jpg',
          alt: 'XBAND Color Options - Classic Black',
          w: 680,
          h: 709,
        },
        {
          file: 'xband-13-color-orange.jpg',
          alt: 'XBAND Color Options - Vitality Orange',
          w: 680,
          h: 713,
        },
        {
          file: 'xband-14-color-green.jpg',
          alt: 'XBAND Color Options - Forest Green',
          w: 680,
          h: 709,
        },
        {
          file: 'xband-15-product-details.jpg',
          alt: 'XBAND Product Details',
          w: 800,
          h: 1189,
          x2: true,
        },
        {
          file: 'xband-16-purchase-benefits.jpg',
          alt: 'XBAND Purchase Benefits',
          w: 800,
          h: 945,
          x2: true,
        },
        {
          file: 'xband-17-timeline.jpg',
          alt: 'XBAND Timeline',
          w: 800,
          h: 1548,
          x2: true,
        },
        {
          file: 'xband-18-sketches.jpg',
          alt: 'XBAND Sketches',
          w: 800,
          h: 540,
          x2: true,
        },
        {
          file: 'xband-19-construction.jpg',
          alt: 'XBAND Construction',
          w: 800,
          h: 605,
          x2: true,
        },
        {
          file: 'xband-20-factory.jpg',
          alt: 'XBAND Factory',
          w: 679,
          h: 503,
        },
        {
          file: 'xband-21-about-us.jpg',
          alt: 'CODEX About Us',
          w: 800,
          h: 1018,
          x2: true,
        },
      ],
    };
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.$store.commit('toggleLoadingScene', 100);
  },
  mounted() {
    this.$store.commit('toggleLoadingScene', 100);
  },
  methods: {
    srcOf(item) {
      return `${this.publicPath}frontend-assets/img/xband/${item.file}`;
    },
    // 没有高清原图的分页返回 false，Vue 不会渲染 srcset 属性，浏览器直接用 src
    // 三档候选：800（1x）/ 1200（高分屏手机）/ 1600（Retina 桌面）
    srcsetOf(item) {
      if (!item.x2) return false;
      const base = `${this.publicPath}frontend-assets/img/xband`;
      return [
        `${base}/1600/${item.file} 1600w`,
        `${base}/1200/${item.file} 1200w`,
        `${base}/${item.file} 800w`,
      ].join(', ');
    },
  },
};
</script>

<style lang="less" scoped>
@import '../styles/vars.less';

.xband-page {
  width: 100%;
  font-size: 0;
  // 让出固定头部的高度，避免首屏图片顶部被 header 遮挡
  // （头部为白色背景，与首屏白底相接，看不出接缝）
  padding-top: 88px;

  @media (max-width: 767px) {
    padding-top: 66px;
  }

  @media (max-width: 575px) {
    padding-top: 50px;
  }

  .section {
    display: block;
    width: 100%;
    // 1x 图为 800px 宽，与页面最大显示宽度一致
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    height: auto;

    // 深色/照片分页保持通栏，避免收窄后两侧出现色差边框
    &.is-full {
      max-width: 100%;
    }
  }

  // 底部下载入口。父级 font-size: 0（消除图片间隙），这里需显式声明字号
  .download-box {
    width: 100%;
    padding: 80px 20px 90px;
    background-color: #f5f5f5;
    text-align: center;

    .download-title {
      margin: 0;
      font-size: 34px;
      font-weight: 500;
      line-height: 1.5em;
      color: #231815;
    }

    .download-desc {
      margin: 14px auto 0;
      max-width: 560px;
      font-size: 16px;
      line-height: 1.75em;
      color: #57585a;
    }

    .download-actions {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 36px;
    }

    .download-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      min-width: 230px;
      margin: 0 8px 16px;
      padding: 14px 26px;
      border-radius: 4px;
      background-color: #231815;
      color: #fff;
      font-size: 16px;
      line-height: 1.2em;
      text-decoration: none;
      transition: background-color 0.3s, transform 0.3s;

      &:hover {
        background-color: #7d6650;
        transform: translateY(-2px);
      }

      .icon {
        flex: 0 0 auto;
        width: 22px;
        height: 22px;
        margin-right: 10px;
        fill: currentColor;
      }
    }

    @media (max-width: 767px) {
      padding: 48px 16px 56px;

      .download-title {
        font-size: 26px;
      }

      .download-desc {
        font-size: 14px;
      }

      .download-actions {
        flex-direction: column;
        align-items: center;
        margin-top: 28px;
      }

      .download-btn {
        width: 100%;
        max-width: 300px;
        min-width: 0;
        margin: 0 0 12px;
      }
    }
  }

  // 固定悬浮购买按钮：水平居中，垂直位置由 top 控制（当前 90%）
  // 样式沿用站点 .more-btn：金色细描边 + 深色底 + hover 金色色块从左滑入
  // 父级 font-size: 0，字号需显式声明
  .buy-float {
    position: fixed;
    z-index: 20;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    box-sizing: border-box;
    min-width: 150px;
    padding: 15px 20px;
    overflow: hidden;
    border: 1px solid @keyColor;
    // 与页面底部下载按钮、muse-ui 组件一致
    border-radius: 4px;
    background-color: @black;
    color: @keyColor;
    font-size: 16px;
    line-height: 1.2em;
    letter-spacing: 2px;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
    transition: color 0.5s;

    // 金色色块从左侧滑入填充
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: -100%;
      z-index: 0;
      width: 100%;
      height: 100%;
      background-color: @keyColor;
      transition: left 0.5s;
    }

    .buy-float-text {
      position: relative;
      z-index: 1;
    }

    &:hover {
      color: @black;

      &::before {
        left: 0;
      }
    }

    @media (max-width: 575px) {
      min-width: 120px;
      padding: 12px 16px;
      font-size: 14px;
      letter-spacing: 1px;
    }
  }
}
</style>
